import React from "react";

export const taxStartGuideContent = {
  texts: {
    subtitle: "Here are some tips and setup tasks to help you get started",
    goal: "Use this guide to get ready for your first tax return.",
    allDone: "You've completed all setup tasks!",
    showPreviousTasks: "Show previous tasks",
    tasksLeft: ({ tasksLeft, minutesLeft }) =>
      `${tasksLeft} tasks left (About ${minutesLeft} minutes)`,
    footerLinks: [
      { label: "Open Help Center", to: "/help" },
      { label: "Go to Transactions", to: "/transactions" },
    ],
    nextActions: [
      {
        title: "Review VAT returns",
        description: "Open a return once your numbers and transactions are in place.",
        label: "Go to VAT returns",
        to: "/vat-returns",
        variant: "primary",
      },
      {
        title: "Check sales tax returns",
        description: "Sales tax permits and returns live with your tax settings.",
        label: "Open tax settings",
        to: "/settings",
      },
      {
        title: "Add another store",
        description: "Connect another marketplace or shop when you are ready.",
        label: "Go to stores",
        to: "/stores",
      },
    ],
  },
  defaultSteps: [
    { id: "1", step: "1", name: "Fill your profile", category: "required" },
    { id: "3", step: "3", name: "Fill tax settings", category: "required" },
    { id: "4", step: "4", name: "Upload transactions", category: "required" },
    { id: "2", step: "2", name: "Add a store", category: "optional", optional: true },
  ],
  steps: {
    1: {
      name: "Fill your profile",
      category: "required",
      description: (
        <>
          Use the English language to fill in your address and company name.
          Information from your profile is used in VAT returns.
        </>
      ),
      to: "/personal-settings",
      actionLabel: "Fill",
      actions: [
        { label: "Fill", to: "/personal-settings", variant: "primary" },
      ],
    },
    2: {
      name: "Add a store",
      category: "optional",
      description: (
        <>
          Connect your Amazon, Shopify, marketplace, or custom store. You can
          configure a domestic country for every store.
        </>
      ),
      to: "/stores/add",
      actionLabel: "Fill",
      actions: [
        { label: "Fill", to: "/stores/add", variant: "primary" },
      ],
    },
    3: {
      name: "Fill tax settings",
      category: "required",
      description: (
        <>
          Add and activate your VAT numbers or sales tax permits before
          uploading transactions because they affect tax calculations.
        </>
      ),
      to: "/settings",
      actionLabel: "Fill",
      actions: [
        { label: "Fill", to: "/settings", variant: "primary" },
      ],
    },
    4: {
      name: "Upload transactions",
      category: "required",
      description: "Upload transactions using a marketplace integration, spreadsheet, API, or plugin.",
      bullets: [
        "Marketplace integration",
        "Manual upload from an Excel spreadsheet",
        "Real-time API integration",
        "Magento or WooCommerce plugins",
      ],
      to: "/transactions/import",
      actionLabel: "Fill",
      actions: [
        {
          label: "Fill",
          to: "/transactions/import",
          variant: "primary",
        },
      ],
    },
  },
};
